import { render, staticRenderFns } from "./CO2Icon.vue?vue&type=template&id=459544ac&scoped=true&"
import script from "./CO2Icon.vue?vue&type=script&lang=js&"
export * from "./CO2Icon.vue?vue&type=script&lang=js&"
import style0 from "./CO2Icon.vue?vue&type=style&index=0&id=459544ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459544ac",
  null
  
)

export default component.exports